"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SF_ORDER_ITEMS_BY_ORDER_NUMBER = void 0;
exports.GET_SF_ORDER_ITEMS_BY_ORDER_NUMBER = `
query getOrderItemsByOrderNumber($orderNumber: String!) {
  getOrderItemsByOrderNumber(orderNumber: $orderNumber)
}
`;
//# sourceMappingURL=order-item-queries.js.map